import React from 'react'
import ButtonWithLoader from '../../components/ButtonWithLoader'
import InputControl from '../../components/InputControl'
import { Controller, useForm } from 'react-hook-form'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { statemanagement, industrymanagement } from '../../Routes/routingConsts'
import { Dropdown, Form, InputGroup, Button } from 'react-bootstrap'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import requestApi from '../../utils/request'
import { useMutation, useQuery } from 'react-query'
import Swal from 'sweetalert2'
import DropDownControlForLocation from '../../components/DropDownControlForLocation'
import { useState } from 'react'
const AddNewState = () => {
    const countryValidationInput = yup.object({
        name: yup.string().required('Please enter state name'),
        country: yup.string().required('Please select country'),
        country: yup.object().test('one-of', 'Please select country', (val) => {
            return (
                val?.countryName !== '' && val?.countryId !== '' && Boolean(val)
            )
        })
    })
    const {
        handleSubmit,
        reset,
        register,
        control,
        formState: { errors }
    } = useForm({ resolver: yupResolver(countryValidationInput) })
    const navigate = useNavigate()
    const { countryId, stateId } = useParams()

    // add - edit state ///
    async function addNewState({ country, ...payload }) {
        if (stateId) {
            return await requestApi
                .post(
                    `state/add-edit`,
                    { ...payload, stateId, countryId: country?.countryId },
                    { headers: true }
                )
                .then((res) => {
                    return res.data
                })
        } else {
            // let countryName = JSON.parse(country)
            return await requestApi
                .post(
                    `state/add-edit`,
                    { ...payload, countryId: country?.countryId },
                    { headers: true }
                )
                .then((res) => {
                    return res.data
                })
        }
    }

    const mutation = useMutation(addNewState, {
        onSuccess: (data) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: '',
                text: data?.meta?.message
            }).then(() => {
                navigate(statemanagement)
            })
        },
        onError: (error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: '',
                text: error?.message
            })
        }
    })
    // End add-edit state////

    // view-state on id //
    async function viewStateOnId(stateId) {
        return await requestApi
            .post(`/state/view`, { stateId: stateId }, { headers: true })
            .then((res) => {
                return res.data
            })
    }
    const { data, isLoading } = useQuery({
        queryKey: ['view-state'],
        queryFn: () => viewStateOnId(stateId),
        enabled: !!stateId,
        onSuccess: (data) => {
            reset({
                country: {
                    countryName: data?.data[0]?.countryName,
                    countryId: data?.data[0]?.countryId
                },
                name: data?.data[0]?.stateName
            })
        }
    })
    // end view state on id //

    ///// list country Api ////
    async function countryList() {
        return await requestApi.post(
            `country/list`,
            { limit: 550 },
            { headers: true }
        )
    }
    const { data: countryDataList } = useQuery({
        queryKey: ['country'],
        queryFn: () => countryList('country')
        // enabled: !!userProfile
    })
    /////end country list api ///

    const onSubmit = ({ ...data }) => {
        const payload = {
            ...data
        }
        mutation.mutate(payload)
    }
    return (
        <>
            <div className="sidebar-content">
                <ul className="nav-links">
                    <Link to={statemanagement}>
                        <li>
                            <a href="">State Management</a>
                            <span>&gt;</span>
                        </li>
                    </Link>
                    <li>
                        {stateId ? (
                            <a className="bold">Edit State</a>
                        ) : (
                            <a className="bold">Add State</a>
                        )}
                    </li>
                </ul>

                <Form onSubmit={handleSubmit(onSubmit)}>
                    <div className="whitebox">
                        {stateId ? (
                            <div className="title-text">
                                <h3>Edit State</h3>
                            </div>
                        ) : (
                            <div className="title-text">
                                <h3>Add State</h3>
                            </div>
                        )}

                        <div className="createnew-box newbox">
                            <div className="row">
                                <div className="col-lg-4 col-md-6 col-12">
                                    <div className="mb-3 input-wrapper">
                                        <DropDownControlForLocation
                                            id={true}
                                            name="country"
                                            label="Country Name"
                                            control={control}
                                            options={
                                                countryDataList?.data?.data
                                            }
                                            // className="icontrol"
                                            register={register}
                                            error={errors.country?.message}
                                            // getCountry={(countryId) => {
                                            //     // setCountryId()
                                            //     // setValue('city', JSON.stringify({ _id: '', name: '' }))
                                            // }}
                                        />
                                    </div>
                                </div>

                                <div className="col-xl-3 col-lg-6 col-md-6 col-12">
                                    <div className="mb-3 input-wrapper">
                                        <InputControl
                                            label="State Name"
                                            name="name"
                                            register={register}
                                            // placeholder='State Name'
                                            error={errors?.name?.message}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* <div className="whitebox"> */}
                    <div className="jobdes-btn">
                        <ButtonWithLoader
                            isLoading={mutation?.isLoading}
                            cssClass="common-btn comman-auth-btn reset-btn"
                        >
                            {stateId ? (
                                <button
                                    type="submit"
                                    className="common-btn create"
                                >
                                    Edit
                                </button>
                            ) : (
                                <button
                                    type="submit"
                                    className="common-btn create"
                                >
                                    Add
                                </button>
                            )}
                        </ButtonWithLoader>
                        <button
                            type="button"
                            className="common-btn cancel"
                            onClick={() => {
                                navigate(statemanagement)
                            }}
                        >
                            Cancel
                        </button>
                    </div>
                    {/* </div> */}
                </Form>
            </div>
        </>
    )
}

export default AddNewState
